import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import cn from 'classnames';
import Markup from 'components/Markup';
import TitleLink from 'components/UI/TitleLink';
import Title from 'components/UI/Title';
import Link from 'components/UI/Link';
import { useTrans } from 'utils/localisation';

import * as styles from './WhatWeDoCard.module.scss';
import * as listStyles from 'commonStyles/list.module.scss';

export default function WhatWeDoCard({
  cardId,
  title,
  description,
  list,
  link,
  target,
  setActive,
}) {
  const t = useTrans(['common', 'whatWeDo']);
  const [inViewRef, inView] = useInView({ threshold: 1 });

  useEffect(() => {
    if (inView && setActive) {
      setActive(cardId);
    }
  }, [inView, cardId, setActive]);

  return (
    <div className={cn(styles.card, styles.animatedDesktop)} id={cardId} ref={inViewRef}>
      <div className={styles.titleWrapper}>
        {link ? (
          <TitleLink tag="h3" size="h4" className={styles.title} href={link}>
            {title}
          </TitleLink>
        ) : (
          <Title tag="h3" size="h4" className={styles.title}>
            {title}
          </Title>
        )}
      </div>
      <div className={styles.content}>
        {description && (
          <Markup className={styles.description} tag="p">
            {description}
          </Markup>
        )}
        {list && (
          <ul className={styles.list}>
            {list.map(listItem => (
              <li key={listItem} className={cn(listStyles.checkedItem, listStyles.md)}>
                {listItem}
              </li>
            ))}
          </ul>
        )}
        <div className={cn(link && styles.linkWrapper)}>
          {link && (
            <Link className={styles.link} href={link} target={target} state={{ internal: true }}>
              {t('seeMore')}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
